var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LogoutPage"},[_c('div',{staticClass:"LogoutPage__loader"},[_c('LoadingIcon')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }